export const MISSING_CUSTOMER_STATEMENT = "Keine weiteren Angaben"

export const resolveCustomerStatement = (value: unknown): string =>
  typeof value === "string" && value.trim() ? value.trim() : MISSING_CUSTOMER_STATEMENT
